import { useAppSelector } from '../../store/hooks'
import { selectAccountId } from '../../store/auth/authSlice'
import React, { useState } from 'react'
import { createState, IntegrationServiceId } from '../../common/integrations'
import { Col, Container, Row } from 'react-bootstrap'
import { ExchangeCredentialsModal } from '../../views/Integration/Connectors/ModalIntegrationConnectors/Exchange/ExchangeCredentialsModal'
import { Tooltip } from '../Tooltip/Tooltip'
import { ScopedBlock } from '../ScopedBlock/ScopedBlock'
import { MissingScopeAction } from '../ScopedBlock/models'
import { SelectDropdown } from '../SelectDropdown/SelectDropdown'
import { Button } from '../Button/Button'
import { ROUTER_BASEPATH } from '../../common/constants'
import { IntegrationIcon } from '../IntegrationIcon'
import { useIntegrations } from '../../views/Integration/useIntegrations'

export const CalendarIntegrationTool = () => {
  const accountId = useAppSelector(selectAccountId)
  const { calendarIntegrationOptions, calendarIntegrationOptionsByIntegration, isIntegrationAllowed } = useIntegrations()

  const [selectedCalendarIntegration, setSelectedCalendarIntegration] = useState<IntegrationServiceId | null>(null)
  const [showExchangeCredentialsModal, setShowExchangeCredentialsModal] = useState<boolean>(false)

  const handleExchangeOnSave = () => {
    setShowExchangeCredentialsModal(false)
  }

  const authorizeCalendar = () => {
    if (selectedCalendarIntegration === IntegrationServiceId.EXCHANGE_CALENDAR) {
      setShowExchangeCredentialsModal(true)
      return
    }
    const redirectUrl = window.location.origin + ROUTER_BASEPATH + `/integrations/callback/${selectedCalendarIntegration!}`
    const redirectUri = encodeURIComponent(redirectUrl)
    const state = createState()
    window.location.href = `${
      import.meta.env.REACT_APP_IAM_API_BASE_URL
    }/accounts/${accountId}/user-integrations/${selectedCalendarIntegration!}/enable?redirect_uri=${redirectUri}&state=${state}`
  }

  return (
    <Container className='d-flex flex-column gap-4 justify-content-between h-100 p-0'>
      <ExchangeCredentialsModal
        serviceId={IntegrationServiceId.EXCHANGE_CALENDAR}
        show={showExchangeCredentialsModal}
        onSave={handleExchangeOnSave}
        onCancel={() => setShowExchangeCredentialsModal(false)}
      />
      <Row>
        <Col xs='auto' className='gx-3'>
          <div className='flex rounded integration-icon-wrapper'>
            <i className='bi bi-calendar2-week '></i>
          </div>
        </Col>
        <Col>
          <h5>Connect your calendar</h5>
          <div className='paragraph-medium zocks-text-gray-600'>
            Connect your Google Calendar or Microsoft Outlook Calendar so that Zocks will automatically join your scheduled meetings.
          </div>
        </Col>
      </Row>
      <Row>
        <Container className='upcoming-integration-bottom-box'>
          <Row className='align-items-center'>
            <Col>
              <div className='paragraph-small zocks-text-gray-600'>It works on</div>
            </Col>
            <Col xs='auto' className='flex align-items-center justify-content-end'>
              {isIntegrationAllowed(IntegrationServiceId.OUTLOOK_CALENDAR) ? (
                <Tooltip title='Outlook Calendar' placement='top'>
                  <IntegrationIcon serviceId={IntegrationServiceId.OUTLOOK_CALENDAR} width={'2rem'} height={'2rem'} className='me-1' />
                </Tooltip>
              ) : null}
              {isIntegrationAllowed(IntegrationServiceId.EXCHANGE_CALENDAR) ? (
                <Tooltip title='Exchange Calendar (On-Premise)' placement='top'>
                  <IntegrationIcon serviceId={IntegrationServiceId.EXCHANGE_CALENDAR} width={'2rem'} height={'2rem'} className='me-1' />
                </Tooltip>
              ) : null}
              {isIntegrationAllowed(IntegrationServiceId.GOOGLE_CALENDAR) ? (
                <Tooltip title='Google Calendar' placement='top'>
                  <IntegrationIcon serviceId={IntegrationServiceId.GOOGLE_CALENDAR} width={'2rem'} height={'2rem'} className='me-1' />
                </Tooltip>
              ) : null}
              {isIntegrationAllowed(IntegrationServiceId.REDTAIL) ? (
                <Tooltip title='Redtail Calendar' placement='top'>
                  <IntegrationIcon serviceId={IntegrationServiceId.REDTAIL} width={'2rem'} height={'2rem'} className='me-1' />
                </Tooltip>
              ) : null}
              {isIntegrationAllowed(IntegrationServiceId.WEALTHBOX_CALENDAR) ? (
                <Tooltip title='Wealthbox Calendar' placement='top'>
                  <IntegrationIcon serviceId={IntegrationServiceId.WEALTHBOX_CALENDAR} width={'2rem'} height={'2rem'} className='me-1' />
                </Tooltip>
              ) : null}
            </Col>
          </Row>
          <Row>
            <Col>
              <ScopedBlock
                scope={{
                  scope: 'integration:connect',
                  superScope: ['integration:admin'],
                }}
                missingScopeAction={MissingScopeAction.DISABLE}
              >
                <SelectDropdown
                  className='zocks-px-0.75 mb-2'
                  initialSelectedOption={selectedCalendarIntegration ? calendarIntegrationOptionsByIntegration[selectedCalendarIntegration] : null}
                  placeholder={'Choose calendar'}
                  options={calendarIntegrationOptions}
                  onOptionSelected={(selected) => setSelectedCalendarIntegration(selected.id as IntegrationServiceId)}
                />
                <Button variant='primary' className='w-100 px-0' onClick={authorizeCalendar} disabled={selectedCalendarIntegration == null}>
                  Connect
                </Button>
              </ScopedBlock>
            </Col>
          </Row>
        </Container>
      </Row>
    </Container>
  )
}
